export async function callResetApi(email: string): Promise<Response> {
    return await fetch("/auth/reset", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            email: email,
        }),
    });
}